import { render, staticRenderFns } from "./filingRoleManagement.vue?vue&type=template&id=0865e924&scoped=true"
import script from "./filingRoleManagement.vue?vue&type=script&lang=js"
export * from "./filingRoleManagement.vue?vue&type=script&lang=js"
import style0 from "./filingRoleManagement.vue?vue&type=style&index=0&id=0865e924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865e924",
  null
  
)

export default component.exports